import React from 'react'
import PropTypes from 'prop-types'
import { UserContext } from 'components/context'
import Documents from './Documents'

const DocumentsWrapper = () => {
  const { membership } = React.useContext(UserContext)

  if (!membership) return null

  return (
    <Documents membership={membership} />
  )
}

DocumentsWrapper.propTypes = {
  membership: PropTypes.object,
}

export default DocumentsWrapper
